import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class TrackingService {

	constructor(private http: HttpClient) { }

	/**
	 * Fetches tracking view configuration for a given public schema
	 * @param id Public schema id
	 * @returns tracking config (schema info, tracking field key, workspace themes…)
	 */
	public async getTrackingConfig(schemaId: string | number): Promise<any> {
		return new Promise((resolve, reject) => {
			this.http.get(`api/tracking/${schemaId}`)
				.subscribe(result => {
					resolve(result);
				}, error => {
					reject(error);
				});
		});
	}

	/**
	 * Searches for an item by its tracking id value
	 * @param publicSchemaId Public schema id
	 * @param trackingId The tracking id value entered by the user
	 * @returns the matching item or 404
	 */
	public async searchItem(publicSchemaId: string | number, trackingId: string): Promise<any> {
		const params = new HttpParams().set('trackingId', trackingId);

		return new Promise((resolve, reject) => {
			this.http.get(`api/searchItem/${publicSchemaId}`, { params })
				.subscribe(result => {
					resolve(result);
				}, error => {
					reject(error);
				});
		});
	}

	/**
	 * Uploads files and associates them with an existing tracked item
	 * @param publicSchemaID Public schema id
	 * @param trackingId The tracking id value of the item
	 * @param files Array of file metadata from Formio file component
	 * @returns the upload result
	 */
	public async uploadTrackingFiles(publicSchemaID: string | number, trackingId: string, files: any[]): Promise<any> {
		return new Promise((resolve, reject) => {
			this.http.post('api/trackingUploadFiles', {
				publicSchemaID,
				trackingId,
				files
			}).subscribe(result => {
				resolve(result);
			}, error => {
				reject(error);
			});
		});
	}
}
